
import { db, auth, storage } from "../../firebase/firebase";
import { ref, uploadBytesResumable, getDownloadURL, UploadTask } from "firebase/storage";


import { getStorage, deleteObject } from "firebase/storage";

export async function deleteImageFromUrl(storageUrl: string): Promise<void> {
  try {
    const storage = getStorage();

    // Parse the URL to get the storage path
    const path = decodeURIComponent(
      storageUrl.split("/o/")[1].split("?")[0]
    );

    // Create a reference to the file
    const fileRef = ref(storage, path);

    // Delete the file
    await deleteObject(fileRef);
    console.log("File deleted successfully");
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error("Error deleting file:", error.message);
    } else {
      console.error("Unexpected error:", error);
    }
    throw error; // Re-throw the error for further handling
  }
}



// const uploadImage = (id:string, file: File): Promise<string> => {
// return new Promise((resolve, reject) => {
//     const storageRef = ref(storage, `storeContent/${id}_${file.name}`);
//     const uploadTask = uploadBytesResumable(storageRef, file);
//     uploadTask.on(
//       "state_changed",
//       snapshot => {
//         const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
//         console.log("upload is" + progress + "% done");
//         switch (snapshot.state) {
//           case "paused":
//             console.log("Upload paused");
//             break;
//           case "running":
//             console.log("Upload running");
//             break;
//           default:
//             break;
//         }
//       },
//       error => {
//         console.log(error);
//         reject(error);
//       },
//       () => {
//         getDownloadURL(uploadTask.snapshot.ref)
//           .then(downloadedURL => {
//             resolve(downloadedURL);
//           })
//           .catch(reject);
//       }
//     );
//   });
// }

export enum FolderName {
  // photos = "photos",
  // video = "video",
  // audio = "audio",
  // document = "document",
  // list = "list_photos",
  channel = "channel_media",
  content = "channel_content_media",
}

export enum SKMediaType {
  none = "none",
  photo = "image",
  video = "video",
  audio = "audio",
  document = "document"
} 
const folderForMediaType= (type: SKMediaType):string => {
    switch (type) {
      case SKMediaType.video:
        return "videos"
      case SKMediaType.photo:
          return "photos"
      case SKMediaType.audio:
          return "audios"
      case SKMediaType.document:
          return "documents"
      case SKMediaType.none:
          return "none";
    }

}

export type SKLocationType = "In Person" | "Online";
export type ProgressCallback = (progress: number, mediType:SKMediaType) => void;
export type ErrorCallback = (error: Error, mediType:SKMediaType) => void;
export type SuccessCallback = (url: string, mediType:SKMediaType) => void;

export const uploadFile = (
  file: File,
  documentId: string,
  mediaType:SKMediaType,
  progressCallback: ProgressCallback,
  errorCallback: ErrorCallback,
  successCallback: SuccessCallback,
  folder?:string,
): UploadTask => {

  
const extension = file.name.split('.').pop();
const uuid = crypto.randomUUID();
const storageRef = ref(storage, `${folder ?? folderForMediaType(mediaType)}/${documentId}/${uuid}.${extension}`);
  //const storageRef = ref(storage, `${folder(mediaType)}/${documentId}/${file.name}`);
  
  const metadata = {
    contentType: file.type,
  };

  const uploadTask = uploadBytesResumable(storageRef, file, metadata);

  uploadTask.on(
    'state_changed',
    (snapshot) => {
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      progressCallback(progress, mediaType);
    },
    (error) => {
      errorCallback(error, mediaType);
    },
    () => {
      getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
        successCallback(downloadURL, mediaType);
      });
    }
  );

  return uploadTask;
};

export const uploadBlob = (
  blob: Blob,
  documentId: string,
  fileName: string,
  fileType: string,
  mediaType:SKMediaType,
  progressCallback: ProgressCallback,
  errorCallback: ErrorCallback,
  successCallback: SuccessCallback,
  folder?:string,
): UploadTask => {


const uuid = crypto.randomUUID();
const storageRef = ref(storage, `${folder ? folder : folderForMediaType(mediaType)}/${documentId}/${uuid}`);
  //const storageRef = ref(storage, `${folder(mediaType)}/${documentId}/${file.name}`);
  
  const metadata = {
    contentType: fileType,
  };

  const uploadTask = uploadBytesResumable(storageRef, blob, metadata);

  uploadTask.on(
    'state_changed',
    (snapshot) => {
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      progressCallback(progress, mediaType);
    },
    (error) => {
      errorCallback(error, mediaType);
    },
    () => {
      getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
        successCallback(downloadURL, mediaType);
      });
    }
  );

  return uploadTask;
};

export const uploadCoverMedia = (
  file: File,
  fileName: string,
  mediaType:SKMediaType,
  documentId: string,
  progressCallback: ProgressCallback,
  errorCallback: ErrorCallback,
  successCallback: SuccessCallback,
  folder:string,
): UploadTask => {

  const fileExtension = file.name.split('.').pop();
  const uuid = crypto.randomUUID();
  const storageRef = ref(storage, `${folder ? folder : folderForMediaType(mediaType)}/${documentId}/${uuid}.${fileExtension}`);
  
  const metadata = {
    contentType: file.type,
  };

  const uploadTask = uploadBytesResumable(storageRef, file, metadata);

  uploadTask.on(
    'state_changed',
    (snapshot) => {
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      progressCallback(progress, mediaType);
    },
    (error) => {
      errorCallback(error, mediaType);
    },
    () => {
      getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
        successCallback(downloadURL, mediaType);
      });
    }
  );

  return uploadTask;
};

export const uploadListPhoto = (
  file: File,
  mediaType:SKMediaType,
  documentId: string,
  progressCallback: ProgressCallback,
  errorCallback: ErrorCallback,
  successCallback: SuccessCallback,
  folder:string
): UploadTask => {

  const fileExtension = file.name.split('.').pop();
  const uuid = crypto.randomUUID();
  const storageRef = ref(storage, `${folder ? folder : folderForMediaType(mediaType)}/${documentId}/${uuid}.${fileExtension}`);
  
  const metadata = {
    contentType: file.type,
  };

  const uploadTask = uploadBytesResumable(storageRef, file, metadata);

  uploadTask.on(
    'state_changed',
    (snapshot) => {
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      progressCallback(progress, mediaType);
    },
    (error) => {
      errorCallback(error, mediaType);
    },
    () => {
      getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
        successCallback(downloadURL, mediaType);
      });
    }
  );

  return uploadTask;
};


export const base64ToBlob = (base64: string): Blob => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: "image/jpeg" });
};

export const uploadOGListImageByte = (
  base64Image: string,
  mediaType:SKMediaType,
  documentId: string,
  progressCallback: ProgressCallback,
  errorCallback: ErrorCallback,
  successCallback: SuccessCallback,
  folder:string
): UploadTask => {

  const uuid = crypto.randomUUID();
  const storageRef = ref(storage, `${folder? folder:folderForMediaType(mediaType)}/${documentId}/${uuid}.${".png"}`);
  const blob = base64ToBlob(base64Image);
  const uploadTask = uploadBytesResumable(storageRef, blob);

  const metadata = {
    contentType: ".png",
  };

  uploadTask.on(
    'state_changed',
    (snapshot) => {
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      progressCallback(progress, mediaType);
    },
    (error) => {
      errorCallback(error, mediaType);
    },
    () => {
      getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
        successCallback(downloadURL, mediaType);
      });
    }
  );
  return uploadTask;
};

